import React from "react";
import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

// Wrapper used by every legal page for consistent typography, spacing, and
// disclaimer footer. This is deliberately a plain component — no design
// changes to the rest of the app.
export default function LegalLayout({ title, effectiveDate, children }) {
  return (
    <>
      <Nav />
      <main className="container-hs py-10 md:py-14 max-w-3xl" data-testid={`legal-${title.toLowerCase().replace(/\s+/g, "-")}`}>
        <span className="badge-soft">Legal</span>
        <h1 className="font-display text-3xl sm:text-4xl text-brand-ink mt-3">{title}</h1>
        {effectiveDate && (
          <p className="text-xs text-brand-muted mt-2">Effective date: {effectiveDate}</p>
        )}
        <div className="mt-6 space-y-5 text-sm leading-relaxed text-brand-ink [&_h2]:font-display [&_h2]:text-xl [&_h2]:text-brand-ink [&_h2]:mt-8 [&_h2]:mb-2 [&_p]:text-brand-muted [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_ul]:text-brand-muted [&_a]:text-brand-accent [&_a]:underline">
          {children}
        </div>
        <div className="rounded-xl border border-brand-warning/40 bg-brand-warning/10 p-4 mt-10 text-xs text-brand-ink leading-relaxed">
          <b>Attorney review recommended.</b> This document was drafted to reflect Home Cost Path's actual data flow and product behavior. It has not been reviewed by a licensed attorney. Please have qualified counsel review these terms before relying on them for compliance with laws applicable to your jurisdiction and business.
        </div>
        <div className="mt-8">
          <Link to="/" className="text-sm text-brand-accent underline">← Back to Home Cost Path</Link>
        </div>
      </main>
      <Footer />
    </>
  );
}
